// Lead import template (Lead Pipeline → Tools → Bulk Import Leads).
// The column headers must match what the API's bulkImportDeals reads.
// Plain columns (no dropdowns): every cell is free text.

export const LEAD_IMPORT_COLUMNS = [
  { header: "First Name", width: 16 },
  { header: "Last Name", width: 16 },
  { header: "Company Name", width: 22 },
  { header: "Industry", width: 18 },
  { header: "Location", width: 16 },
  { header: "Company website", width: 24 },
  { header: "Department", width: 16 },
  { header: "Designation", width: 20 },
  { header: "Emails", width: 28, note: "Several emails? Separate them with commas. The first one becomes the main email." },
  { header: "Phone Numbers", width: 20, note: "Required. Several numbers? Separate them with commas — the first is the main number, the rest are saved as alternate numbers." },
  { header: "Alternate Number", width: 18 },
  { header: "LinkedIn Profile", width: 30 },
  { header: "Date (any IMP)", width: 16, date: true, note: "Any important date for this lead (e.g. meeting or renewal date)." },
  { header: "Status", width: 16, note: "If this matches one of your pipeline stage names, the lead is placed in that stage. Any other text is kept as the lead's status and the lead starts in the first stage." },
  { header: "Remarks", width: 30 },
  { header: "Lead owner", width: 20, note: "Name or email of the team member the lead is assigned to. Leave empty to use the usual assignment." },
  { header: "Requirement: Product/ service", width: 28, note: "Product or service the lead needs. New values are added to your Categories automatically." },
  { header: "Lead source", width: 16 },
];

const colLetter = (index) => {
  let n = index + 1;
  let s = "";
  while (n > 0) {
    const m = (n - 1) % 26;
    s = String.fromCharCode(65 + m) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
};

// Rows pre-formatted as dates in the "Date (any IMP)" column
const FORMATTED_ROWS = 1000;

/** Builds and downloads the .xlsx template. */
export const downloadLeadImportTemplate = async () => {
  const ExcelJS = (await import("exceljs")).default;
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Leads", { views: [{ state: "frozen", ySplit: 1 }] });

  ws.columns = LEAD_IMPORT_COLUMNS.map((c) => ({ header: c.header, key: c.header, width: c.width }));

  // Header style + hints
  const header = ws.getRow(1);
  header.height = 22;
  LEAD_IMPORT_COLUMNS.forEach((c, i) => {
    const cell = header.getCell(i + 1);
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: c.header === "Phone Numbers" ? "FF4338CA" : "FF6366F1" } };
    cell.alignment = { vertical: "middle" };
    if (c.note) cell.note = c.note;
  });

  // No example row: it would be imported as a real lead if left in.
  // Guidance lives in the header cell notes instead.

  // Date column shows dates as 19-Nov-2026
  LEAD_IMPORT_COLUMNS.forEach((c, i) => {
    if (!c.date) return;
    const col = colLetter(i);
    for (let r = 2; r <= FORMATTED_ROWS + 1; r++) ws.getCell(`${col}${r}`).numFmt = "dd-mmm-yyyy";
  });

  const buffer = await wb.xlsx.writeBuffer();
  const url = URL.createObjectURL(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = "Lead_Import_Template.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
